import React, { useEffect, useState } from 'react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { fetchUserAttributes } from 'aws-amplify/auth';
import { useNavigate } from 'react-router-dom';
import './Header.css';
import logo from '../assets/Fox-River-AI-Logo.png';
import ScrollableNav from './ScrollableNav';

const Header = () => {
  // Make authentication optional for public pages
  let user, signOut;
  try {
    const auth = useAuthenticator((context) => [context.user]);
    user = auth.user;
    signOut = auth.signOut;
  } catch (error) {
    // No authentication context available (public page)
    user = null;
    signOut = null;
  }
  const [fullAttributes, setFullAttributes] = useState({});
  const [showAccountMenu, setShowAccountMenu] = useState(false);
  const navigate = useNavigate();
  
  const goToHomePage = () => {
    navigate('/');
  };

  // Get display name with priority order using complete attributes
  const displayName = fullAttributes.name || // Full name (highest priority)
                     (fullAttributes.email ? fullAttributes.email.split('@')[0] : null) || // Email username
                     (user?.username?.startsWith('google_') ? 'Google User' : null) || // Social providers
                     (user?.username?.startsWith('loginwithamazon_') ? 'Amazon User' : null) ||
                     (user?.username?.startsWith('signinwithapple_') ? 'Apple User' : null) ||
                     'User'; // Default fallback

  const handleSignOut = async () => {
    try {
      await signOut({ global: true });
      navigate('/');
    } catch (error) {
      console.error('Error signing out: ', error);
    }
  };

  useEffect(() => {
    if (user) {
      // Fetch complete user attributes directly from Cognito
      const getUserAttributes = async () => {
        try {
          const attrs = await fetchUserAttributes();
          console.log('Complete user attributes:', attrs);
          setFullAttributes(attrs);
        } catch (error) {
          // Ignore token revocation errors during logout
          if (error.name !== 'NotAuthorizedException') {
            console.error('Error fetching user attributes:', error);
          }
        }
      };
      
      getUserAttributes();
    } else {
      // Clear attributes when user logs out
      setFullAttributes({});
    }
  }, [user]);

  return (
    <header className="header">
      <div className="header-top">
        <div className="header-left" onClick={goToHomePage} style={{ cursor: 'pointer' }}>
          <img src={logo} alt="Company Logo" className="logo" />
          <div className="company-info">
            <h1 className="company-name">Fox River AI</h1>
            <p className="slogan">Affordable AI, Powerful Solutions</p>
          </div>
        </div>
        <div className="header-right">
          <p className="contact-info">Call today: (630) 940-8837</p>
          {user && (
            <div className="account-menu-container">
              <button 
                onClick={() => setShowAccountMenu(!showAccountMenu)}
                className="account-button"
              >
                {displayName} ▼
              </button>
              {showAccountMenu && (
                <div className="account-dropdown">
                  <button 
                    onClick={() => {
                      setShowAccountMenu(false);
                      navigate('/account');
                    }}
                    className="dropdown-item"
                  >
                    My Account
                  </button>
                  <button 
                    onClick={() => {
                      setShowAccountMenu(false);
                      handleSignOut();
                    }}
                    className="dropdown-item"
                  >
                    Log Out
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <ScrollableNav />
    </header>
  );
};

export default Header;